import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePrevious } from 'js/hooks/usePrevious';
import { useCombinedHandler } from 'js/hooks/useCombinedHandler';

/**
 * Adds listeners on location.pathname change
 * @param {Array<Function>|Function} listener
 */
export const useSubscribeOnLocationChange = (listener) => {
    const { pathname } = useLocation();
    const prevPathname = usePrevious(pathname);
    const combinedListener = useCombinedHandler(Array.isArray(listener) ? listener : [listener]);

    useEffect(() => {
        if (prevPathname && pathname !== prevPathname) {
            combinedListener();
        }
    }, [pathname, prevPathname, combinedListener]);
};
